/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParameterNameResponseDto } from './ParameterNameResponseDto';
import {
    ParameterNameResponseDtoFromJSON,
    ParameterNameResponseDtoFromJSONTyped,
    ParameterNameResponseDtoToJSON,
    ParameterNameResponseDtoToJSONTyped,
} from './ParameterNameResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListParameterNamesResponseDto
 */
export interface ListParameterNamesResponseDto {
    /**
     * 
     * @type {Array<ParameterNameResponseDto>}
     * @memberof ListParameterNamesResponseDto
     */
    data: Array<ParameterNameResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListParameterNamesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListParameterNamesResponseDto interface.
 */
export function instanceOfListParameterNamesResponseDto(value: object): value is ListParameterNamesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListParameterNamesResponseDtoFromJSON(json: any): ListParameterNamesResponseDto {
    return ListParameterNamesResponseDtoFromJSONTyped(json, false);
}

export function ListParameterNamesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListParameterNamesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ParameterNameResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListParameterNamesResponseDtoToJSON(json: any): ListParameterNamesResponseDto {
    return ListParameterNamesResponseDtoToJSONTyped(json, false);
}

export function ListParameterNamesResponseDtoToJSONTyped(value?: ListParameterNamesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ParameterNameResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

